import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/systemadmin/_layout/')({
  beforeLoad: () => {
    // Default redirect to users page (matches original Content.tsx behavior)
    throw redirect({
      to: '/systemadmin/users',
    });
  },
});
